import React from 'react';
import { ThemeProvider } from 'styled-components';
import Landing from './pages/Landing';
import { Provider } from 'react-redux';
import store from './store';

import '@gerdau/hefesto-design-tokens/css/globals.css';
import '@gerdau/hefesto-design-tokens/css/default/theme-1/light.css';
import GlobalStyle from './assets/styles/global';
import theme from './assets/styles/theme/theme';
import CustomAntdStyle from './assets/styles/custom-antd';
import './assets/styles/custom-antd.less';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/es/locale/pt_BR';
import { FiscalBenefitProvider } from '../src/context/fiscalBenefitContext';

const App = () => {
  return (
    <ConfigProvider locale={ptBR}>
      <ThemeProvider theme={theme}>
        <FiscalBenefitProvider>
          <Provider store={store}>
            <GlobalStyle />
            <CustomAntdStyle />

            <Landing />
          </Provider>
        </FiscalBenefitProvider>
      </ThemeProvider>
    </ConfigProvider>
  );
};

export default App;
